import { getAudioContext } from "./interactivity";
import { getMediaUrl } from "./navigation";

let playingSounds = null;
let targetAmbiance = null;
export const startAmbiance = async (ambiance) => {
  targetAmbiance = ambiance;
  const url = getMediaUrl(ambiance);
  const r = await fetch(url, {
    mode: "cors"
  });
  const b = await r.arrayBuffer();
  const context = getAudioContext();
  const buffer = await context.decodeAudioData(b);
  if (ambiance !== targetAmbiance) {
    // exit if target modified
    return;
  }
  const source = context.createBufferSource();
  playingSounds = source;
  source.buffer = buffer;
  source.loop = true;
  source.connect(context.destination);
  source.start(0);
};

export const killAmbiance = () => {
  targetAmbiance = null;
  if (playingSounds) {
    playingSounds.stop();
    playingSounds.disconnect();
    playingSounds.buffer = null;
    playingSounds = null;
  }
  // https://storage.googleapis.com/dev-maisonsirois/piece3/anecdote-piece3.mp3
};
